export const indPerformancestableColumns = [
   {
     id: "S.No",
     label: "S.No",
     minWidth: 70,
     align: "left",
   },
   {
     id: "user.employeeId",
     label: "Employee Id",
     minWidth: 150,
     align: "left",
   },
   {
     id: "name",
     label: "Property Visit",
     minWidth: 70,
     align: "left",
   },
   {
     id: "dateOfVisit",
     label: "Date Of Visit",
     minWidth: 70,
     align: "left",
   },
   {
     id: "startTime",
     label: "Start time",
     minWidth: 70,
     align: "left",
   },
  
 ];
 
 export const eventsFormFields = [
   {
     name: "title",
     label: "Title",
     type: "text",
     required: false,
     disabled: true,
   },
   {
     name: "eventType",
     label: "Event Type",
     type: "text",
     required: false,
     disabled: true,
   },
   {
     name: "organizer",
     label: "Organizer",
     type: "text",
     required: false,
     disabled: true,
   },
   {
     name: "startDate",
     label: "Event Start Date",
     type: "date",
     required: false,
   },
   {
     name: "startTime",
     label: "Event Start Time",
     type: "time",
     required: false,
   },
   {
     name: "endDate",
     label: "Event End Date",
     type: "date",
     required: false,
   },
   {
     name: "endTime",
     label: "Event End Time",
     type: "time",
     required: false,
   },
   {
     name: "address",
     label: "Address",
     type: "text",
     required: false,
     disabled: true,
   },
   {
     name: "city",
     label: "City",
     type: "text",
     required: false,
     disabled: true,
   },
   {
     name: "country",
     label: "Country",
     type: "text",
     required: false,
     disabled: true,
   },
 ];
 